module.exports = __webpack_public_path__ + "static/media/download_icon.50f1104c.svg";